<div class="pricing-wrapper">
	<regscale-all></regscale-all>

	<regscale-difference2></regscale-difference2>

	<pricing-features></pricing-features>

	<affordable-options></affordable-options>

	<more-than-license></more-than-license>
</div>

<ready-set></ready-set>
